import { render } from "./menu.vue?vue&type=template&id=090f0865&scoped=true"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"

import "./menu.vue?vue&type=style&index=0&id=090f0865&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-090f0865"

export default script